import { Component } from "react";
import Layout from "../../../componentes/Comunes/Layout/Layout";
import { Modificacion } from "../../../componentes/Padron/ComponenteModificacion/Modificacion";

export class ModificacionSolicitud extends Component {
  render() {
    return (
      <Layout>
        <div>
          <Modificacion />
        </div>
      </Layout>
    );
  }
}
